import React from 'react';
import StayService from '../../../services/StayService';
import { faSuitcase } from '@fortawesome/free-solid-svg-icons';
import CrudManager from '../../../components/common/CrudManager';

const Stay = () => {

  const columns = [
    {
      key: 'file',
      label: 'stay.file',
      sortable: false,
      showInGrid: false,
      showInForm: true,
      type: 'file',
      accept: '.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
      fullWidth: true,
      required: (formData, isEditing) => !isEditing
    },
    {
      key: 'fileName',
      label: 'stay.fileName',
      sortable: true,
      showInFilter: true,
      filterSize: 'large'
    },
    {
      key: 'userRegistrationName',
      label: 'stay.userRegistration',
      sortable: true,
      showInFilter: false
    },
    {
      key: 'registrationDate',
      label: 'stay.registrationDate',
      sortable: true,
      showInFilter: true,
      className: 'grid-date',
      render: (row) => row.registrationDate ? new Date(row.registrationDate).toLocaleString() : ''
    },
    {
      key: 'status',
      label: 'stay.status',
      sortable: true
    },
    {
      key: 'importLog',
      label: 'stay.importLog',
      type: 'textarea',
      sortable: false,
      maxLengthInGrid: 80,
      showInFilter: true,
      filterSize: 'large'
    },
    {
      key: 'enabled',
      label: 'stay.enabled',
      showInGrid: false,
      sortable: false,
      showInFilter: false,
      filterType: 'checkbox',
      filterSize: 'small'
    }
  ];

  return (
    <CrudManager
      service={StayService}
      columns={columns}
      entityName="stay"
      icon={faSuitcase}
      formLayout="modal"
      canEdit={false}
      canDelete={true}
    />
  );
};

export default Stay;
